"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  return <section id="hero" className="relative w-full bg-background overflow-hidden !bg-[url(https://huge-sunbird.10web.cloud/wp-content/uploads/2026/03/lake_tile4.webp)]">
      <style dangerouslySetInnerHTML={{
      __html: `
        :root {
          --font-sans: 'Inter', 'Geist', ui-sans-serif, system-ui, -apple-system, sans-serif;
          --text-hero: clamp(3.5rem, 12vw, 7rem);
          --weight-light: 300;
          --tracking-hero: -0.04em;
        }

        #hero {
          font-family: var(--font-sans);
          font-weight: var(--weight-light);
        }

        #hero h1 {
          font-size: var(--text-hero);
          font-weight: var(--weight-light);
          line-height: 1.1;
          letter-spacing: var(--tracking-hero);
          margin-bottom: 1.5rem;
          text-transform: uppercase;
        }
      `
    }} />
      
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/hero_nature_background.png)] bg-cover bg-center bg-no-repeat" />

      <div className="absolute inset-0 bg-black/30" />

      <div className="relative z-10 mx-auto flex min-h-[400px] w-full max-w-7xl flex-col items-center justify-center px-4 py-32 text-center sm:min-h-[500px] sm:px-6 md:py-40 lg:px-8">
        <h1 ref={ref} className={`max-w-6xl text-white transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Unterricht
        </h1>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-white/80 text-sm md:text-base uppercase tracking-widest font-light">
          <a href="#wochenplan" className="hover:text-white transition-colors flex items-center">
            <span className="mr-2 opacity-50">•</span>
            Wöchentliche Kurse
          </a>
          <a href="#aktuelle-seminare" className="hover:text-white transition-colors flex items-center">
            <span className="mr-2 opacity-50">•</span>
            Seminare & Workshops
          </a>
          <a href="#einzelstunden-coaching" className="hover:text-white transition-colors flex items-center">
            <span className="mr-2 opacity-50">•</span>
            Individuelle Begleitung
          </a>
        </div>
      </div>
    </section>;
}